import usePartnerPrograms from '@platform-ui-common/hooks/contexts/PartnerPrograms/index.js';
import usePartner from '@platform-ui-common/hooks/contexts/usePartner.js';
import { generatePlaceholders } from '@platform-ui-common/hooks/usePlaceholder.js';
import useAuth from '@platform-ui/auth/hooks/useAuth/index.js';
import { getApplicationConfiguration } from '@platform-ui/utilities/application/configs/index.js';
import { usePostHog } from 'posthog-js/react';
import useUserApplications from '../useUserApplications.js';
import getStatusBlocks, { StatusBlockSection } from './getStatusBlocks.js';
import mapStatus from './mapStatus/index.js';
import { ApplicationStatusBlock } from './types.js';

export default function useApplicationStatusBlocks(): {
  [section in StatusBlockSection]: ApplicationStatusBlock[];
} {
  const partner = usePartner();
  const { programs } = usePartnerPrograms();
  const applications = useUserApplications();
  const { user } = useAuth();
  const posthog = usePostHog();
  const blocks = getStatusBlocks(programs, applications, user.core);
  return Object.fromEntries(
    Object.entries(blocks).map(([section, sectionBlocks]) => [
      section,
      sectionBlocks.map(({ program, application }) => ({
        id: application?.id ?? program.id,
        title: program.name,
        ...mapStatus(
          {
            application,
            config: getApplicationConfiguration(program, user.core),
            partner,
            program,
            placeholders: generatePlaceholders({
              application,
              partner,
              program,
              user: user.core,
            }),
            user: user.core,
          },
          posthog,
        ),
      })),
    ]),
  ) as { [section in StatusBlockSection]: ApplicationStatusBlock[] };
}
